module.exports = __webpack_public_path__ + "assets/img/14_1765_big.2bb25d64.jpg";